<template>
  <div class="base-area">
    <div v-if="rec.dispJitsuUnsoTaiseiKanriList && rec.dispJitsuUnsoTaiseiKanriList.length > 0" class="pt-1">
      <span class="ml-1 view-required-description">※がついている項目は、法定必須項目です。</span>
    </div>
    <v-row no-gutters>
      <v-col :cols="12">
        <dd-spread-sheet
          v-model="rec.dispJitsuUnsoTaiseiKanriList"
          ref="dispJitsuUnsoTaiseiKanriList"
          :column="jitsuUnsoTaiseiKanriHeaders"
          :options="option"
          :contextMenu="null"
          :dropDownList="[]"
          :isUseDownloadToolbar="true"
          :isUseControlToolbar="true"
          :isUseSaveToolbar="saveUseFlg"
          :isUseAddRow="true"
          :isUseDeleteRow="true"
          useAddRowText="管理簿に入力行を追加"
          :useDeleteRow="true"
          :outsideErrorList="outsideErrorList"
          @deleteRow="rowDelete"
          @addRow="rowAppend"
          @addRowAbove="rowAppendAvobe"
          @refresh="refresh"
          @save="saveRowData"
          @download="onExcelButtonClick"
        >
        </dd-spread-sheet>
        <a id="download" href="#" style="display:none;">ダウンロード</a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import date from '@/ddv2.library/date'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import indexeddb from '@/ddv2.library/indexeddb'
import DdSpreadSheet from '@/components/DdSpreadSheet'

const addStyle = '<span style="color:white;font-size:0.7rem;padding:4px;background-color:green;border-radius:15px">ADD</span>'

export default {
  name: 'DdJitsuUnsoTaiseiKanriboSpread',
  mixins: [flowMixin],
  components: {
    DdSpreadSheet
  },
  props: {
    /**
     * Object
     */
    rec: Object,
    /**
     * 傭車依頼のときはtrueに
     */
    yoshaFlg: {
      type: Boolean,
      default: false
    },
    /**
     * 傭車先ID
     */
    yoshaId: {
      type: Number,
      default: 0
    },
    /**
     * 傭車車両ID
     */
    yoshaSharyoId: {
      type: Number,
      default: 0
    },
    /**
     * 傭車車番
     */
    yoshaSharyoNo: {
      type: String,
      default: ''
    },
    /**
     * 傭車人員ID
     */
    yoshaJininId: {
      type: Number,
      default: 0
    },
    /**
     * readOnly
     */
    readOnly: {
      type: Boolean,
      default: false
    },
    /**
     * ページネーション値（指定されなければ 10）
     */
    pagination: {
      type: Number,
      default: 10
    },
    /**
     * 保存ボタン使うときはtrueに
     */
    saveUseFlg: {
      type: Boolean,
      default: false
    },
    /**
     * headersの列固定数
     */
    freezeColumns: {
      type: Number,
      default: 0
    },
    /**
     * addRelationColumnMode
     */
    addRelationColumnMode: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      // 表示用
      jitsuUnsoTaiseiKanriHeaders: [],
      // 保存用
      appendCount: 0,
      // スプレッドシートオプション
      option: {
        // minDimensions: [0, 50],
        toolbar: true,
        // テーブル最大高さ
        tableHeight: '50vh',
        // テーブル最大横幅
        tableWidth: 'inherit',
        // 列固定
        freezeColumns: this.freezeColumns,
        // 列追加
        allowInsertColumn: false,
        // 行追加※改行キーのみ
        allowManualInsertRow: false,
        // 列削除
        allowDeleteColumn: false,
        // 行削除
        allowDeleteRow: false,
        // 列ドラッグ
        columnDrag: false,
        // 行ドラッグ
        rowDrag: false,
        // ソート
        columnSorting: true,
        // スクロール有効化
        tableOverflow: true,
        // コンテキストメニュー
        contextmenu: false,
        // セル内HTML無効※ヘッダー改行のため有効
        stripHTML: false,
        // 計算式のサポート
        parseFormulas: false,
        // セル選択時の右下の■ドラッグでのコピー
        selectionCopy: true,
        // CSV出力
        allowExport: false,
        // フィルターオプション
        search: true,
        // ページネーションオプション
        pagination: this.pagination,
        paginationOptions: [10, 25, 50, 100]
      },
      newRecordId: 0,
      // 画面側からのエラーリスト
      outsideErrorList: []
    }
  },
  computed: {
    ...mapGetters({
      xlsImportMappingList: 'DDMasters/mstXlsImportMapping',
      sharyoList: 'DDMasters/vwCMstSharyo',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    computedColNumList () {
      var result = {}
      this.jitsuUnsoTaiseiKanriHeaders.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    }
  },
  watch: {
    yoshaFlg: function () {
      this.setJitsuUnsoTaiseiKanriHeader()
    },
    xlsImportMappingList: {
      immediate: true,
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          this.setJitsuUnsoTaiseiKanriHeader()
        }
      }
    }
  },
  beforeDestroy () {
  },
  created () {
  },
  mounted () {
    // マスタ読み込み
    this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlsimportmapping', 'msttorihikisaki', 'msthinmei', 'msthacchakuchi'], version: 1 })
    this.setJitsuUnsoTaiseiKanriHeader()
  },
  methods: {
    /**
     * 実運送体制管理ヘッダ作成
     */
    setJitsuUnsoTaiseiKanriHeader: function () {
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        // const target = filter.dateFormatter(new Date())
        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        self.jitsuUnsoTaiseiKanriHeaders = []
        // マスタ情報から自動生成
        self.xlsImportMappingList.filter(function (elem) {
          return elem.formatCd === (self.addRelationColumnMode ? 'UnsoKanriboWithRel' : 'UnsoTaiseiKanribo')
        }).sort((a, b) => {
          if (a.columnNo - b.columnNo !== 0) { return a.columnNo - b.columnNo }
          return -1
        }).forEach((elem) => {
          var dropdownList = null
          self.jitsuUnsoTaiseiKanriHeaders.push({
            title: elem.columnNm,
            name: elem.bindItemNm,
            type: elem.standardInputFlg !== true ? null : elem.inputType,
            customInput: elem.standardInputFlg === true ? null : elem.inputType,
            validateType: elem.validateType,
            required: elem.requiredFlg,
            readOnly: elem.readonlyFlg,
            autocomplete: elem.autocompleteFlg,
            width: elem.width + 'px',
            source: dropdownList,
            customInputSuffix: elem.inputSuffix,
            customInputLength: elem.inputLength,
            customInputIntDigit: elem.inputIntDigit,
            customInputDecimalDigit: elem.inputDecimalDigit,
            align: elem.headerStyle === null ? undefined : elem.headerStyle
          })
        })
        resolve()
      })
    },
    setRowData: function (pid, mno, pUserEigyoshoNm) {
      this.newRecordId -= 1
      const newrow = {
        rowNo: this.rec.dispJitsuUnsoTaiseiKanriList.length + 1,
        id: this.newRecordId,
        memo: addStyle,
        trJuchuMeisaiId: this.newRecordId,
        editFlg: true,
        errFlg: false,
        delFlg: false,
        editMode: false,
        maninushiNm: null,
        tsumikomiYmd: date.getCurrentDate(),
        unsoKukan: null,
        unsoHinmoku: null,
        ukeoiKaiso: null,
        jitsuUnsoJigyoshaNm: null,
        jitsuUnsoSharyoNm: null,
        jitsuUnsoJomuinNm: null,
        jitsuUnsoBiko: null
      }

      if (![undefined, null, ''].includes(this.rec.maninushiNm)) {
        newrow.maninushiNm = this.rec.maninushiNm
      }

      if (![undefined, null, ''].includes(this.rec.hatsuchiId)) {
        const hatsuchiInfo = indexeddb.getRecord(this.hacchakuchiList, this.rec.hatsuchiId)
        newrow.unsoKukan = ![undefined, null, ''].includes(hatsuchiInfo) ? hatsuchiInfo.hacchakuchiNm : ''
      } else if (![undefined, null, ''].includes(this.rec.hatsuchiBiko)) {
        newrow.unsoKukan = this.rec.hatsuchiBiko
      }

      if (![undefined, null, ''].includes(this.rec.chakuchiId)) {
        const chakuchiInfo = indexeddb.getRecord(this.hacchakuchiList, this.rec.chakuchiId)
        const chakuchiNm = ![undefined, null, ''].includes(chakuchiInfo) ? chakuchiInfo.hacchakuchiNm : ''
        newrow.unsoKukan = ![undefined, null, ''].includes(newrow.unsoKukan) ? newrow.unsoKukan + ' ~ ' + chakuchiNm : chakuchiNm
      } else if (![undefined, null, ''].includes(this.rec.chakuchiBiko)) {
        const chakuchiNm = this.rec.chakuchiBiko
        newrow.unsoKukan = ![undefined, null, ''].includes(newrow.unsoKukan) ? newrow.unsoKukan + ' ~ ' + chakuchiNm : chakuchiNm
      }

      if (![undefined, null, ''].includes(this.rec.mstHinmeiId)) {
        const hinmeiInfo = indexeddb.getRecord(this.hinmeiList, this.rec.mstHinmeiId)
        newrow.unsoHinmoku = ![undefined, null, ''].includes(hinmeiInfo) ? hinmeiInfo.hinmeiNm : ''
      } else if (![undefined, null, ''].includes(this.rec.hinmeiBiko)) {
        newrow.unsoHinmoku = this.rec.hinmeiBiko
      }

      if (newrow.rowNo === 1) {
        if (this.yoshaId > 0) {
          const hacchusakiInfo = indexeddb.getRecord(this.torihikisakiList, this.yoshaId)
          newrow.jitsuUnsoJigyoshaNm = ![undefined, null, ''].includes(hacchusakiInfo) ? hacchusakiInfo.torihikisakiNm : ''
        }

        if (![undefined, null, ''].includes(this.yoshaSharyoId)) {
          const yoshaSharyoInfo = indexeddb.getRecord(this.sharyoList, this.yoshaSharyoId)
          newrow.jitsuUnsoSharyoNm = ![undefined, null, ''].includes(yoshaSharyoInfo) ? yoshaSharyoInfo.jidoshaHyojiNm : ''
        } else if (![undefined, null, ''].includes(this.yoshaSharyoNo)) {
          newrow.jitsuUnsoSharyoNm = this.yoshaSharyoNo
        }

        if (this.yoshaJininId > 0) {
          const yoshaJininInfo = indexeddb.getRecord(this.eigyoshoJininList, this.yoshaJininId)
          newrow.jitsuUnsoJomuinNm = ![undefined, null, ''].includes(yoshaJininInfo) ? yoshaJininInfo.jininNmSei : ''
        }
      }
      return newrow
    },
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    rowAppend: function (num, aboveFlg) {
      var activeC = this.$refs.dispJitsuUnsoTaiseiKanriList.getActiveCell()
      // 現在の並び順のデータ
      // var rowsCurrentOrder = this.$refs.ddSpreadSheet.getDataCurrentOrder()
      // 行追加先の位置を取得
      var pos = 0
      var posMax = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択
        pos = Math.max(...[activeC[1], activeC[3]]) + 1
        // 複数行制御用に最終行も取得
        posMax = Math.max(...[activeC[1], activeC[3]])
        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      const appendCount = posMax - pos + num ? num : 1
      const newrows = Array.from({ length: appendCount }, () => this.setRowData())

      // 行追加
      if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
        if (pos === 0) {
          this.rec.dispJitsuUnsoTaiseiKanriList.unshift(...newrows)
          pos = 0
        } else {
          this.rec.dispJitsuUnsoTaiseiKanriList.splice(pos - 1, 0, ...newrows)
          pos = pos - 1
        }
      } else {
        if (![undefined, null].includes(pos)) {
          this.rec.dispJitsuUnsoTaiseiKanriList.splice(pos, 0, ...newrows)
        } else {
          this.rec.dispJitsuUnsoTaiseiKanriList.splice(this.rec.dispJitsuUnsoTaiseiKanriList.length, 0, ...newrows)
        }
      }

      // 行番号が狂うので外部からのエラー設定は消去
      this.outsideErrorList = []
    },
    rowDelete: function (num, index) {
      console.log('rowDelete : ', num, index)
      if ([undefined, null, ''].includes(index)) { return }
      const targetId = this.rec.dispJitsuUnsoTaiseiKanriList[index].id
      if (targetId > 0) {
        // 既存行の場合は削除フラグを立てる
        const targetRow = this.rec.jitsuUnsoTaiseiKanriList.find(item => item.id === targetId)
        targetRow.delFlg = true
      }
      this.rec.dispJitsuUnsoTaiseiKanriList.splice(index, 1)
      this.rec.dispJitsuUnsoTaiseiKanriList = [...this.rec.dispJitsuUnsoTaiseiKanriList]
      this.$forceUpdate()
    },
    refresh: function () {
      if (this.rec.jitsuUnsoTaiseiKanriList && this.rec.jitsuUnsoTaiseiKanriList.length > 0) {
        this.Effects.loadStart()
        const tmpConditions = {
          idList: this.rec.jitsuUnsoTaiseiKanriList.map((item) => {
            return item.id
          })
        }
        this.HttpClient.post('/api/v1/TrJitsuUnsoTaiseiKanribo/search', tmpConditions)
          .then((data) => {
            const res = data.payload

            res.map((elem) => {
              elem.tsumikomiYmd = elem.tsumikomiYmd ? filter.dateFormatter(elem.tsumikomiYmd) : ''
              return elem
            })
            this.rec.jitsuUnsoTaiseiKanriList = Object.assign([], res) || []
            this.rec.dispJitsuUnsoTaiseiKanriList = Object.assign([], res) || []
            this.Effects.loadComplete()
          })
      }
    },
    convertKanriboResult: function (p) {
      if (p.dispJitsuUnsoTaiseiKanriList.length > 0) {
        p.jitsuUnsoTaiseiKanriList = p.jitsuUnsoTaiseiKanriList.filter((elem) => {
          return elem.delFlg === true
        })
        p.jitsuUnsoTaiseiKanriList.push(...p.dispJitsuUnsoTaiseiKanriList)
      }
      return p
    },
    saveRowData: function () {
      this.$emit('save')
    },
    onExcelButtonClick: function (e) {
      if (this.rec.jitsuUnsoTaiseiKanriList && this.rec.jitsuUnsoTaiseiKanriList.length > 0) {
        this.Effects.loadStart()
        const tmpConditions = {
          idList: this.rec.jitsuUnsoTaiseiKanriList.map((item) => {
            return item.id
          })
        }
        this.HttpClient
          .requestFileByPost('/api/v1/TrJitsuUnsoTaiseiKanribo/ExcelOutput', tmpConditions)
          .then((data) => {
            const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const elem = document.getElementById('download')
            elem.href = window.URL.createObjectURL(blob)
            elem.download = '実運送体制管理_' + ts + '.xlsx'
            elem.click()
            this.Effects.loadComplete()
          })
      }
    }
  }
}
</script>
<style scoped>
</style>
